import { useTranslation } from 'react-i18next'
import Field from '../field'
import { FC } from 'react'


interface ITextArea {

    label: string
    value: string
    setValue: Function
}

const TextArea: FC<ITextArea> = ({ label, value, setValue }) => {
    const { t } = useTranslation()

    return (
        <Field label={t(`${label}`) || ""} className={"col-sm-12"} id={`${label}`}>
            <textarea className='address-textarea' value={value} onChange={(e) => setValue(e.target.value)} ></textarea>
        </Field >
    )
}

export default TextArea